import { Link } from "@tanstack/react-router";
import { m } from "@/paraglide/messages";

const linkClass =
  "pct-panel flex items-center gap-2.5 rounded-xl px-4 py-3 text-sm font-medium transition-colors hover:border-primary/50 hover:bg-primary/[0.08]";

/** Links between the hub and the haiku page. */
export function SylMoreLinks({ current }: { current?: "hub" | "haiku" }) {
  return (
    <section className="mt-12">
      <h2 className="mb-4 font-display text-xl font-bold tracking-tight">
        {m.syl_more_title()}
      </h2>
      <div className="grid gap-3 sm:grid-cols-2">
        {current !== "hub" && (
          <Link to="/syllable-counter" className={linkClass}>
            <span aria-hidden>🔤</span>
            <span>{m.syl_nav_main()}</span>
          </Link>
        )}
        {current !== "haiku" && (
          <Link to="/syllable-counter/haiku" className={linkClass}>
            <span aria-hidden>🎋</span>
            <span>{m.syl_nav_haiku()}</span>
          </Link>
        )}
      </div>
    </section>
  );
}
